import { abyssColors } from '@/theme/colors';
import { Box, TextField, Typography, styled as muiStyled } from '@mui/material';

export const CaptionBox = muiStyled(Box)({
  marginTop: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const CaptionTextField = muiStyled(TextField)({
  padding: 0,
  margin: 0,
  '& .MuiOutlinedInput-root': {
    padding: '0 8px',
    fontSize: '1.2rem',
    fontFamily: 'Roboto',
    fontWeight: 400,
    lineHeight: '14.06px',
    minHeight: '22px',
    borderRadius: '6px',
    width: 70,
    maxWidth: 200,
    outline: 'none',
    background: 'transparent',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    transition: 'width 0.1s',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #E0E0E0',
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '4px 0',
    minWidth: 40,
    width: '100%',
    maxHeight: 80,
    overflowY: 'auto',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
});

export const CaptionTypography = muiStyled(Typography)({
  fontSize: '1.2rem',
  fontWeight: 400,
  textAlign: 'center',
  color: abyssColors.primary[500],
  maxWidth: 200,
  cursor: 'pointer',
  paddingLeft: 4,
  paddingRight: 4,
});

export const ImageCaption = muiStyled(Typography)({
  marginTop: '12px',
  textAlign: 'center',
  fontWeight: 700,
  fontSize: '1.4rem',
  cursor: 'pointer',
  color: abyssColors.primary[500],
});
